import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import PageWrapper from '../page-wrapper/page-wrapper';

const UserProfile = () => {
  const { currentUser, isAdmin } = useAuth();

  if (!currentUser) {
    return (
      <PageWrapper>
        <div className="container mt-5 pt-5">
          <div className="alert alert-warning">
            You must be logged in to view this page.
          </div>
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <div className="container mt-5 pt-5">
        <div className="card">
          <div className="card-header">
            <h2>User Profile</h2>
            {isAdmin && (
              <span className="badge bg-primary ms-2">Administrator</span>
            )}
          </div>
          <div className="card-body">
            <h5 className="card-title">Email</h5>
            <p className="card-text">{currentUser.email}</p>
            
            <h5 className="card-title">User ID</h5>
            <p className="card-text">{currentUser.uid}</p>
            
            <h5 className="card-title">Email Verified</h5>
            <p className="card-text">{currentUser.emailVerified ? 'Yes' : 'No'}</p>
            
            <h5 className="card-title">Account Created</h5>
            <p className="card-text">
              {currentUser.metadata?.creationTime
                ? new Date(currentUser.metadata.creationTime).toLocaleString()
                : 'Unknown'}
            </p>
            
            {isAdmin && (
              <div className="mt-4">
                <h5 className="card-title">Admin Actions</h5>
                <Link to="/admin" className="btn btn-primary">
                  Go to Admin Dashboard
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default UserProfile;